import React from 'react';
import AiChart from './AiChart';

function MessageBubble({ msg }) {
  const isUser = msg.role === 'user';
  const chartData = !isUser && msg.chart_data ? msg.chart_data : null;

  return (
    <div style={{
      display: 'flex', gap: 10,
      flexDirection: isUser ? 'row-reverse' : 'row',
      alignItems: 'flex-start',
    }}>
      <div style={{
        width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
        background: isUser ? '#2563EB' : '#EFF6FF',
        color: isUser ? '#fff' : '#1D4ED8',
        border: isUser ? 'none' : '1px solid #BFDBFE',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 11, fontWeight: 500,
      }}>
        {isUser ? '나' : 'AI'}
      </div>
      <div style={{ maxWidth: '82%', display: 'flex', flexDirection: 'column', gap: 8 }}>
        {msg.content && (
          <div style={{
            padding: '10px 14px',
            borderRadius: isUser ? '12px 4px 12px 12px' : '4px 12px 12px 12px',
            background: isUser ? '#2563EB' : '#F8FAFC',
            color: isUser ? '#fff' : '#1E293B',
            fontSize: 13, lineHeight: 1.65, whiteSpace: 'pre-wrap',
          }}>
            {msg.content}
          </div>
        )}
        {chartData && <AiChart chartData={chartData} />}
      </div>
    </div>
  );
}

export default MessageBubble;